import React, { Fragment, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { Tooltip } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Stats } from '../../components/Stats';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { GraphDialog } from '../../common/components/charts/GraphDialog';
import { GraphHelper } from '../../common/components/charts/GraphHelper';
import { AppHelper } from '../../helpers/AppHelper';
import { GraphUiHelper } from '../../helpers/GraphUiHelper';
import { DateRangePicker } from '../../common/components/charts/DateRangePicker';
import { SearchBar } from '../../common/components/SearchBar';
import { Toast } from '../../components/Toast';
import { ApiHelper } from '../../common/helpers/ApiHelper';

export class DeviceActivity extends BaseEntityPage {
  pageKey = 'DeviceActivity';
  orgId = this.props.match.params.orgId || 'PRODUCT';
  deviceId = this.props.match.params.id
  noAdd = true;
  state = {
    dateStart: moment().subtract(30, 'day').format('YYYY-MM-DD'),
    dateEnd: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    stats: [],
    items: [],
    showToast: false,
    severity: 'info',
    toastMsg: ''
  };

  constructor(props, options) {
    super(props, options);
    if (this.deviceId) {
      this.pageTitle = Helper.getString('deviceExchangeReports')
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute() },
        { title: Helper.getString('deviceExchangeReports') },
      ];
    } else {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute() },
        { title: Helper.getString('searchExchangeReports') },
      ];
      this.pageTitle = Helper.getString('searchExchangeReports');
    }
    this.chartOptions = GraphHelper.getdoughnutChartOptions()
    this.lineChartOptions = GraphHelper.getLineChartOptions()
    this.noTableHead = true
    this.tableHeadersMap = {
      Index: (current) => {
        return (
          <span className={css(Styles.indexStyle)}>{current.__index + 1}</span>
        )
      },
      Venue: (current) => {
        return GraphUiHelper.getVenueInfo(current)
      },
      Info: (current) => {
        return (
          GraphUiHelper.getExchangesOverallData(current)
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    if (this.options.pageForOrgType === 'PARTNER') this.toFetch = this.makeFetches();
    // this.headerActions = [
    //   {
    //     label: Helper.getString('partnerReport'),
    //     onClick: () => this.exportReports({ reportType: 'partner' })
    //   },
    //   {
    //     label: Helper.getString('internalReport'),
    //     onClick: () => this.exportReports({ reportType: 'internal' })
    //   },
    // ]
  }

  componentDidMount() {
    if (this.options.pageForOrgType === 'PARTNER') this.fetchItems()
  }

  exportReports = ({ reportType }) => {
    const prefixes = ['get_', 'ads_', 'pop_', 'err_', 'latestStrErr_'];
    // eslint-disable-next-line no-undef
    const exchangesSet = new Set();
    // eslint-disable-next-line no-undef
    const metricKeysSet = new Set();
    // Loop through all items and collect keys
    this.state.items.forEach(item => {
      Object.keys(item).forEach(key => {
        if (prefixes.some(p => key.startsWith(p))) {
          metricKeysSet.add(key)
          exchangesSet.add(key.split('_')[1])
        }
      });
    });
    const exchanges = [...exchangesSet]
    const metricKeys = [...metricKeysSet]
    if (reportType === 'internal') {
      const headers = {
        deviceTitle: 'deviceTitle',
        deviceCode: 'deviceCode',
        'site.title': 'siteTitle',
        'site.address': 'siteAddress',
        serialNumber: 'serialNumber',
        hf: 'firstOnlineAt',
        noOfhrsOnline: 'noOfhrsOnline',
        cmsPop: 'cmsPop',
        adapireqs: 'adapireqs'
      }
      for (const ex of exchanges) {
        for (const prefix of prefixes) {
          if (metricKeys.includes(prefix + ex))
            headers[prefix + ex] = prefix === 'ads_' ? 'lsd_' + ex : prefix + ex
        }
      }
      this.customExport = {
        buttonTitle: Helper.getString('internalReport'),
        headers: headers,
        format: 'xlsx'
      }
      this.setState({
        dataToDownload: this.state.items
      }, () => {
        this.onExport({ reportType })
      })
    } else if (reportType === 'partner') {
      const headers = {
        deviceTitle: 'deviceTitle',
        deviceCode: 'deviceCode',
        noOfhrsOnline: 'onlineHours',
        adapireqs: 'adApiReqs',
        cmsPop: 'cmsPop',
        programmaticLease: 'programmaticLease',
        programmaticPop: 'programmaticPop'

      }
      for (const item of this.state.items) {
        let getExchange = 0
        let popExchange = 0
        for (const ex of exchanges) {
          getExchange = getExchange + (item['ads_' + ex] || 0)
          popExchange = popExchange + (item['pop_' + ex] || 0)
        }
        item.programmaticLease = getExchange
        item.programmaticPop = popExchange
      }
      this.customExport = {
        buttonTitle: Helper.getString('partnerReport'),
        headers: headers,
        format: 'xlsx'
      }
      this.setState({
        dataToDownload: this.state.items
      }, () => {
        this.onExport({ reportType })
      })
    }
  }

  onExport({ reportType }) {
    if (this.customExport && this.customExport.format === 'xlsx') {
      const DwnldUtil = require('../../common/helpers/FileDownloader');

      const fileName = this.makeFileName({ reportType });
      const rows = this.prepExcelDownload()
      DwnldUtil.FileDownloader.exportAsExcelFile(rows, fileName)
    }
  }

  prepExcelDownload() {
    const rows = [];

    for (const item of this.state.dataToDownload) {
      const e = {};
      for (const hKey in this.customExport.headers) {
        e[this.customExport.headers[hKey]] = this.exportRowItemValue(hKey, item)
      }
      rows.push(e);
    }
    return rows
  }

  exportRowItemValue(key, current) {
    const serialNumber = current.latestDeviceFeed && current.latestDeviceFeed.serialnumber
      ? current.latestDeviceFeed.serialnumber
      : current.serialNumber

    switch (key) {
    case 'site.title':
      return current.site && current.site.title ? current.site.title : ''
    case 'site.address':
      return current.site && current.site.address ? current.site.address : ''
    case 'serialNumber':
      return serialNumber || ''
    case 'hf':
      return current.hf ? Helper.formatDate2({ utcTimestamp: current.hf, format: 'hh:mm a' }) : ''
    default:
      return super.exportRowItemValue(key, current)
    }
  }

  makeFetches = () => {
    const { dateStart, dateEnd } = this.state;
    const queryParams = {}
    if (dateStart) queryParams.startPeriod = dateStart.replaceAll('-', '')
    if (dateEnd) queryParams.endPeriod = dateEnd.replaceAll('-', '')
    if (this.deviceId && this.options.pageForOrgType === 'PARTNER') queryParams.deviceId = this.deviceId
    return [
      { method: 'GET', paths: ['miscs', 'deviceactivity'], queryParams },
      { method: 'GET', paths: ['devices', this.deviceId] }
    ];
  };

  onError = (toastMsg) => {
    this.setState({
      showToast: true,
      severity: 'error',
      toastMsg
    });
  }

  getToast = () => {
    return (
      <Toast
        open={this.state.showToast}
        severity={this.state.severity}
        message={this.state.toastMsg}
        handleClose={() => this.setState({ showToast: false })}
      />
    )
  }

  onFetchSuccess = (results) => {
    this.setState({ showSearchResults: true });
    // Stats ------
    const statusInfo = AppUiHelper.getDaStatsInfo()
    const pStats = []
    // pStats.push({
    //   title: statusInfo.totalVenues.title,
    //   value: results[0].items.length,
    //   image: statusInfo.totalVenues.image,
    //   order: statusInfo.totalVenues.order,
    // })
    for (const [key, value] of Object.entries(results[0].stats)) {
      if (!statusInfo[key]) continue
      pStats.push({
        title: statusInfo[key].title,
        value: AppHelper.formatNumberStats(value || 0),
        image: statusInfo[key].image,
        order: statusInfo[key].order
      })
    }
    const pResult = this.processData(results[0])
    const processedItems = AppHelper.processVenueItemsFromDa(pResult.items)
    this.setState({
      stats: Helper.sortDictArray(pStats),
      items: processedItems.reverse(),
      dpChartsData: pResult.dpChartsData,
      inProcessSearch: false,
      device: results[1]
    });
    if (this.deviceId) {
      this.pageTitle = Helper.getString('deviceExchangeReports') + ' ' + results[1].deviceCode
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute() },
        { title: Helper.getString('exchangeReports'), to: this.baseRoute() + '/devices-activity/' },
        { title: Helper.getString('deviceExchangeReports') + ' ' + results[1].deviceCode },
      ];
    }
  };

  processData = (result) => {
    const labels = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
    const chartTitle = 'Heartbeat By Hour'
    for (const item of result.items) {
      item.hbGraphData = GraphHelper.generateLineGraphData({ chartTitle, labels, data: item.statusByHour })
    }
    result.dpChartsData = this.generateDataForDoughNutGraph(result)
    return result
  }

  generateDataForDoughNutGraph(result) {
    const dp = {}
    for (const key in result.stats) {
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = result.stats[key]
    }
    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = key
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      const data = []
      const labels = []
      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['totalPop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalPop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['totalGet_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalGet_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['totalAds_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalAds_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['totalErr_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['totalErr_' + key] || 0)
        labels.push(`${label} (${value})`)
      }
      let allZero = true
      for (const d of data) {
        if (d !== 0) {
          allZero = false
          break
        }
      }
      if (allZero) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data }))
    }
    return dpChartsData
  }

  generateDataForDoughNutGraphForVenue(current) {
    const dp = {}
    const latestError = {}
    for (const key in current) {
      if (key.startsWith('latestErr_')) {
        const code = key.split('_')[1]
        latestError[code] = {
          code,
          error: current[key]
        }
      }
      const splitArr = key.split('_')
      if (splitArr.length !== 2) continue
      if (!dp[splitArr[1]]) dp[splitArr[1]] = {}
      dp[splitArr[1]][key] = current[key]
    }
    const dpChartsData = []
    for (const key in dp) {
      const chartTitle = key
      const labelsWithoutCounter = ['POP', 'GET', 'LEASED', 'ERROR']
      const data = []
      const labels = []
      for (const label of labelsWithoutCounter) {
        let value = 0;
        if (label === 'POP') data.push(dp[key]['pop_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['pop_' + key] || 0)
        if (label === 'GET') data.push(dp[key]['get_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['get_' + key] || 0)
        if (label === 'LEASED') data.push(dp[key]['ads_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['ads_' + key] || 0)
        if (label === 'ERROR') data.push(dp[key]['err_' + key] || 0), value = AppHelper.formatNumberStats(dp[key]['err_' + key] || 0)
        labels.push(`${label} (${value})`)
      }

      let allZero = true
      for (const d of data) {
        if (d !== 0) {
          allZero = false
          break
        }
      }
      if (allZero) continue
      dpChartsData.push(GraphHelper.generateDoughNutGraphData({ chartTitle, labels, data, latestError }))
    }
    return dpChartsData
  }

  generateTableMap = (items = {}) => {
    const map = {};
    Object.keys(items).forEach((key) => {
      if (key !== 'id') {
        map[items[key]] = (current) => <div>{current[key]}</div>;
      }
    });
    return map;
  };

  onTableValue = (current, index) => {
    if (!this.tableHeaders[index]) return '';
    return this.tableHeadersMap[this.tableHeaders[index]](current);
  };

  onFilter = (filters) => {
    this.setState(
      filters,
      () => {
        this.toFetch = this.makeFetches();
        this.fetchItems();
      }
    );
  };

  onSearch = async (searchText) => {
    if (!searchText || searchText === '') {
      this.setState({
        stats: [],
        items: [],
        dpChartsData: []
      })
      return
    }
    this.setState({
      inProcessSearch: true
    })
    const { dateStart, dateEnd } = this.state;
    const queryParams = {}
    if (dateStart) queryParams.startPeriod = dateStart.replaceAll('-', '')
    if (dateEnd) queryParams.endPeriod = dateEnd.replaceAll('-', '')

    if (searchText) {
      const venueCodes = searchText
        .split(',')
        .map(code => code.trim())  // remove spaces
        .filter(Boolean);          // remove empty strings
      if (venueCodes.length > 1) {
        this.onError(Helper.getString('deviceActivitySearchError'))
        return
      } else {
        queryParams.venueCodesStr = venueCodes
      }
    }
    if (this.deviceId && this.options.pageForOrgType === 'PARTNER') queryParams.deviceId = this.deviceId
    try {
      const response = await ApiHelper.callAwait({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['miscs', 'deviceactivity'], queryParams),
      })
      this.onFetchSuccess([response])
    } catch (err) {
      this.onError(Helper.getErrorMsg(err))
      this.setState({
        inProcessSearch: false
      })
    }
  }

  delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  makeFileName = ({ reportType }) => {
    const dateRange = this.state.dateStart.replaceAll('-', '') + '-to-' + this.state.dateEnd.replaceAll('-', '')
    if (reportType === 'partner') {
      return `external-report-${this.orgId}-${dateRange}`
    } else {
      return `dd-diagnostics-${this.orgId}-${dateRange}`
    }
  }

  onDateChange = ({ dateStart, dateEnd }) => {
    this.setState({
      dateEnd,
      dateStart
    })
  }

  renderAboveTable = () => {
    const { items, stats } = this.state;
    return (
      <div className={css(Styles.renderAboveTable)}>
        <DateRangePicker
          buttonLabel={''}
          hideFilterButton={this.options.pageForOrgType !== 'PARTNER' ? true : false}
          onFilter={this.onFilter}
          dateEnd={this.state.dateEnd}
          dateStart={this.state.dateStart}
          onDateChange={this.onDateChange}
        />
        {this.options.pageForOrgType !== 'PARTNER' &&
          <div className={css(Styles.searchContainer)}>
            <SearchBar
              hint={Helper.getString('deviceActivitySearchHint')}
              inProcessSearch={this.state.inProcessSearch || false}
              onSearch={this.onSearch.bind(this)}
              searchText={this.state.searchText}
              showRecentButtonText={'Search'}
            >
            </SearchBar>
          </div>
        }
        {this.state.showSearchResults &&
          <Fragment>
            {stats && <Stats items={stats}></Stats>}
            {this.state.dpChartsData && this.state.dpChartsData.length > 0 &&
              <Grid className={css(Styles.chartsContainer)} container spacing={2}>
                {this.state.dpChartsData.map((x, index) => {
                  if (!x.data.datasets[0].data || x.data.datasets[0].data.length === 0) return ''
                  return (
                    <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
                      <div className={css(Styles.chartOuterWrap)} >
                        <div className={css(Styles.chartBlock)} >
                          {x.chartTitle &&
                            <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                          }
                          {x.hasDataMoreThanZero === false ?
                            <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                            <Doughnut className={css(Styles.chartCanvas)} data={x.data} options={this.chartOptions} width={100} height={100} />}
                        </div>
                      </div>
                    </Grid>
                  )
                })}
              </Grid>
            }
            {this.state.showVenueGraphs &&
              <GraphDialog
                isOpen={this.state.showVenueGraphs}
                lineChartData={this.state.current.hbGraphData}
                lineChartOptions={this.lineChartOptions}
                title={(this.state.current && this.state.current.deviceCode) ? this.state.current.deviceCode : Helper.getString('venueInfo')}
                onClosed={() => this.setState({ showVenueGraphs: false })}
                fullWidth={true}
                doughnutChartData={this.generateDataForDoughNutGraphForVenue(this.state.current)}
              />
            }
          </Fragment>
        }
        {this.getToast()}
      </div>
    );
  };

  onActions = (current) => {
    const actions = []
    actions.push(
      <Tooltip title='Screen Ad Details' placement='top-start' key={current.id + 'Preview'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/eye.svg')} onClick={() => { this.setState({ showVenueGraphs: true, current }) }} />
        </span>
      </Tooltip>
    )
    return actions
  }
}

const Styles = StyleSheet.create({
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5
  },
  statsInnerContainer: {
    display: 'flex',
    gap: 15,
    borderBottom: '1px solid #d7d7d7b5',
    padding: '5px 0px',
    width: 'max-content'
  },
  dpText: {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValueText: {
    // fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    padding: '3px 6px',
    borderRadius: 4,
    minWidth: 20,
    textAlign: 'center'
  },
  statsValues: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  venueColumn: {
    display: 'flex',
    gap: 7,
    flexDirection: 'column'
  },
  spanValue: {},
  img: {
    height: 30,
  },
  line2: {
    fontSize: 12,
  },
  renderAboveTable: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  circleFill: {
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  fullWidth: {
    width: '100%',
  },
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    '@media (max-width: 1025px)': {
      width: '97vw !important'
    }
  },
  eachChartHolder: {
    // padding:0,
    // marginBottom:12
  },
  eachChartHolder2: {
    // padding:0,
    // marginBottom:12
    width: '100%'
  },
  chartsContainer: {
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  chartOuterWrap: {
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartOuterWrap2: {
    background: '#fff',
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    // background: '#fff',
    // marginRight:10,
    // overflow: 'hidden',
    height: 160
  },
  chartTitle: {
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas: {
    marginBottom: 10
  },
  statsHolder: {
    padding: '0 10px'
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/DeviceActivity.js